import axios from 'axios';
import apiUrl from '../../../constants'

export default new class {
  async getClientCountForDashboard(input) {
    try {
      let result = await axios({
        method: 'GET',
        'url': apiUrl.api_url + 'cargoclientkyc/getclientcountfordashboard',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async checkClientTermsConditionDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/checkClientTermsConditionDetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async getclientTermsConditionDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/getclientTermsConditionDetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async saveclienttermsandcondition(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/saveclienttermsandcondition',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async getClientList(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargoclientkyc/getclientlist',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async getClientNameExist(input) {
    try {
      let result = await axios({
        method: 'POST',
        //'url': apiUrl.api_url + 'cargoclientkyc/clientonboard',
        'url': apiUrl.api_url + 'cargoclientkyc/clientonboardsp',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async addclientkycInfo(input) {
    try {
      let result = await axios({
        method: 'POST',
        //'url': apiUrl.api_url + 'cargoclientkyc/addclientkycInfo',
        'url': apiUrl.api_url + 'cargoclientkyc/addclientkycInfosp',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async uploadDocment(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'awsutils/uploadDocment',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async createAnnexure(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargoclient/saveannexure',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async getAnnexureListing(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargoclient/getAnnexureList',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async removeAnnexureData(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargoclient/removeAnnexuredata',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async saveOtherInformation(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargoclient/saveotherinfo',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async getProductCategoryList(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargoexternal/getProductCategoryList',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async getCompanyShortName(input) {
    try {
      let result = await axios({
        method: 'GET',
        'url': apiUrl.api_url + 'external/getCargoClientList',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async getClientOtherInfoList(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargoclient/getclientotherinfolist',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async updateClientOtherInfoDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargoclient/updateotherinformation',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async changeStatus(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'ChangeStatus',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async sendForApproveInKYC(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'approvalhierarchy/approvalrequest',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async getClientInfoExist(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'approvalhierarchy/getClientInfoExist',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getclientinfo(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'approvalhierarchy/getclientinfo',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async getClientContractList(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/getcontractlist',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async getClientServicesList(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/getcontractservicelist',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async getClientTCList(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/gettermsandconditionlist',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async getClientRatesList(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/getratelist',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async getClientAnnexureList(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/getcontractannexurelist',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async saveClientContractAnnexure(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/savecontractannexures',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async getClientContractDropdownList(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/getcontractlistfordropdown',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async removeClientAnnexureData(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/removeclientannexuredata',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async saveClientContract(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/savecontract',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async saveClientContractServices(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/SaveContractServicesForClient',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async getClentContractDetial(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/getClentContractDetial',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async getClientContractMasterServicesDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/getClientContractMasterServicesDetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async getClientServicesDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/getClientServicesDetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async copyContractRate(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/copycontractrate',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async getBDList() {
    try {
      let result = await axios({
        method: 'GET',
        'url': apiUrl.api_url + 'cargoclientkyc/getbdlist'
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async getClientBDList(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargoclientkyc/getclientbddetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async getOtherInformationForClientList(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargoclient/getclientotherinfo',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async copyContract(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/copycontract',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };

  async getApprovalLogAgainObjectID(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'approvalhierarchy/getapprovallogagainobjectid',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
  async getActiveInactiveClientList() {
    try {
      let result = await axios({
        method: 'GET',
        'url': apiUrl.api_url + 'external/cargoclientkyc/getactiveinactiveclient',
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getClientRateList(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargomaster/clientcontract/getClientRateList',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };

  async updateLastModifiedDate(input) {
    try {
      let result = await axios({
        method: 'PUT',
        'url': apiUrl.api_url + 'cargoclientkyc/updatelastmodifieddate',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };

  async GetClientListByActiveContracts(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/getclientlistbyactivecontracts',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };

  async getCompleteClientContractDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/contractdetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };

  async getClientSKUList(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargoclient/getskulist',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getClientKYCDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargoclientkyc/getdetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getClientAccountKYCDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargoclientkyc/getkycdetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getClientUOM(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargoclient/getuom',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };

  async uploadClientLocation(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'uploaddata/uploadclientlocation',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };

  async getUploadLocationListForConsignee(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'uploaddata/getuploadlocationlistforconsignee',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };

  async getUploadLocationListForPickup(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'uploaddata/getuploadlocationlistforpickup',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async saveClientHubs(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargoclient/saveclienthubs',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getClientHubs(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargoclient/getclienthubs',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async GetCargoClientList(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargoclientkyc/getcargoclientlist',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getClientBasicDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargoclientkyc/getclientbasicdetails',
        'data': input
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getClientServicesDetailsforView(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/getClientServicesDetailsforView',
        'data': input
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getClientServicesDetailsforDownload(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/getClientServicesDetailsforDownload',
        'data': input
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getClientServicesDetailsCount(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/getClientServicesDetailsCount',
        'data': input
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getClientBoxTypeMapping(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargoclient/getboxtypeconfig',
        'data': input
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async saveClientBoxTypeMapping(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargoclient/saveboxtypeconfig',
        'data': input
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getAllClientBoxType(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargoclient/getallclientboxtype',
        'data': input
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async updateContractExtensionDate(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/updateclientcontractextension',
        'data': input
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async bulkUpdateContractExtensionDate(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/bulkupdateclientcontractextension',
        'data': input
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getClientContractLogs(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'clientcontract/getclientcontractlogs',
        'data': input
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/services/clientmanagement.service.js